
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/iforklift",
      function () {
        return require("private-next-pages/iforklift/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/iforklift"])
      });
    }
  